<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="5">
            <el-radio  size="mini"   @change="list" v-model="radio" label="1">文档</el-radio>
            <el-radio  size="mini"   @change="list"  v-model="radio" label="2">视频</el-radio>
            <el-radio  size="mini"   @change="list"  v-model="radio" label="3">笔记</el-radio>
            <el-radio  size="mini"   @change="list"  v-model="radio" label="4">代码</el-radio>
          </el-col>
          <el-col :span="3">
            <el-form-item label="创建人">
              <el-input     v-model="searchParams.tname"></el-input>
            </el-form-item>
          </el-col>
          <el-col   :span="5">
            <el-form-item label="名称">
              <el-input   v-model="searchParams.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col    :span="7">
            <el-form-item label="科目">
              <el-input     placeholder="请选择科目" disabled v-model="sbname">
              <template slot="append">
                <el-button    type="primary" @click="selectSub()">{{ sbname ? '重选' : '选择' }}</el-button>
              </template>
            </el-input>
            </el-form-item>
          </el-col>
          <div class="search-btn">
            <el-button     type="success"   @click="search">搜索</el-button>
            <el-button    @click="clearSearchVal">清空</el-button>
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="toSave()">添加</el-button>
      <el-button type="danger"  size="mini" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange" v-loading="listLoading">
        <el-table-column type="selection" width="40" fixed="left"></el-table-column>
        <el-table-column v-if="radio==2"  width="165" prop="vtm" label="录制时间"></el-table-column>
        <el-table-column v-else prop="crtm" width="165" label="添加时间"></el-table-column>

        <el-table-column prop="kid"  width="260" label="科目">
          <template slot-scope="scope">
            <span v-if="scope.row.kid">{{ scope.row.dbColumn_kid }}</span>
            <el-tag v-else size="mini" type="danger"  >未绑定</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="title"  label="标题"></el-table-column>
    
        <el-table-column prop="types" width="95" label="类型">
          <template slot-scope="scope">
            <div v-if="scope.row.types == 1">知识点教学</div>
            <span v-else-if="scope.row.types == 2">难点解析</span>
            <span v-else-if="scope.row.types == 3">项目操作</span>
            <span v-else-if="scope.row.types == 4">操作演示</span>
            <span v-else >技术文档</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" width="75"  v-if="radio==2"   label="时长min"></el-table-column>
        <el-table-column prop="tname" width="75" label="创建人"></el-table-column>
        <!-- <el-table-column prop="remarks" label="授课笔记"></el-table-column> -->
        <el-table-column prop="vsite" width="75"  v-if="radio==2"  label="平台">
          <template slot-scope="scope">
            <div v-if="scope.row.vsite == 1">B站</div>
            <span v-else-if="scope.row.vsite == 2">其它</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="320px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
                <a :href="scope.row.url"  v-if="scope.row.type < 3"   target="_blank">
                  <el-button size="mini"   >打开URL</el-button>&nbsp;
                </a>&nbsp;
              <el-button size="mini"  @click="toDetail(scope.$index, scope.row)">详情</el-button>
              <el-button size="mini" @click="toUpdate(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini"  type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
        <!-- 选择科目 -->
        <el-dialog title="选择绑定科目" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
        <tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList" :data="permissionList" :defaultParent="0" @nodeClick="treeClick" :expand-on-click-node="true"> </tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmSub">选定科目</el-button>
        </span>
      </el-dialog>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total" :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout" :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
  </div>
</template>
<script>
import edit from './edit.vue'
import api from '@/api/edu/videoes/videoes.js'
import subApi from '@/api/edu/subject/subject.js'
import tree from '@/components/tree/tree.vue'
export default {
  name: 'videoes',
  components: {
    edit,tree
  },
  data() {
    return {
      radio:'2',

      sbname: '', //科目名称
      dialogVisible: false, //科目弹框开关
      subData: [], //选中的科目信息
      //---树--选择题型 模态框弹出为false
      innerVisible: false,
      // 树 的最后一个的id集
      subIds: [],
      //课程-模块-科目信息 全部数据
      orgPermissionList: null,
      permissionList: null,
      //选中的全部节点
      selectedIds: [],

      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj()
    }
  },
  methods: {
     // 选择科目
     selectSub() {
      this.dialogVisible = true
      if (!this.orgPermissionList) {
          subApi.list({}, response => {
            this.orgPermissionList = response.data
            this.permissionList =  this.orgPermissionList
          })
       }else{
         this.permissionList =  this.orgPermissionList
       }
    },
    treeClick(data) {
      this.subData = data
      this.searchParams.kid = this.subData.id
    },
    comfirmSub() {
      this.sbname = this.subData.name
      this.searchParams.kid = this.subData.id
      this.list()
      this.dialogVisible = false
    }, // ---------------选择题型按钮部分-------
    //为题目选择课程-模块-科目信息
    handleCloseTree(done) {
      this.$confirm('确定关闭吗？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    //获取数据
    list() {
      this.listLoading = true
      this.searchParams.types = this.radio
      let params = this.$utils.merger(this.searchParams, this.page)
      api.list(params, response => {
        this.listData = response.data
        this.listLoading = false
      })
    },
    //去添加
    toSave() {
      this.$refs.edit.open({}, this.radio,false,this)
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id
      }
      this.$refs.edit.open(editParameter,  this.radio,false,this)
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id
      }
      this.$refs.edit.open(detailParameter,   this.radio, true)
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id
      }
      this.$utils.confirm.warning('提示', '确定删除吗？', () => {
        api.remove(
          parameter,
          response => {
            this.$utils.msg.success(response.msg)
            this.list()
          },
          response => {
            this.$utils.msg.warning(response.msg)
          }
        )
      })
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info('请选择至少一行')
        return
      }
      let parameter = {
        ids: this.selected
      }
      this.$utils.confirm.warning('提示', '确定删除吗？', () => {
        api.remove(
          {
            ids: this.selected
          },
          response => {
            this.$utils.msg.success(response.msg)
            this.list()
          },
          response => {
            this.$utils.msg.warning(response.msg)
          }
        )
      })
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = []
      for (let item of val) {
        this.selected.push(item.id)
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val
      this.list()
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val
      this.list()
    },

    //搜索
    search() {
      this.list()
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {}
      this.sbname =""
      this.list()
    }
  },
  mounted() {
    this.list()
  }
}
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
